var map = {
	"./radio-ai.jpg": "7100",
	"./radio-asyik.jpg": "1f3a",
	"./radio-bintulu.jpg": "4598",
	"./radio-bisnes.png": "c290",
	"./radio-johor.jpg": "50ac",
	"./radio-kedah.jpg": "cacf",
	"./radio-kelantan.jpg": "0cd6",
	"./radio-keningau.jpg": "c6c4",
	"./radio-kl.jpg": "f96d",
	"./radio-klasik.jpg": "3f48",
	"./radio-labuan.jpg": "71b6",
	"./radio-langkawi.jpg": "39e3",
	"./radio-limbang.jpg": "c3c1",
	"./radio-melaka.jpg": "6e40",
	"./radio-minnal.jpg": "ffb1",
	"./radio-miri.jpg": "138d",
	"./radio-mutiara (1).jpg": "95fe",
	"./radio-mutiara.jpg": "9350",
	"./radio-muzik-fm.png": "63ff",
	"./radio-nasional.jpg": "40e8",
	"./radio-negeri-sembilan.jpg": "0d8b",
	"./radio-pahang.jpg": "758c",
	"./radio-perak.jpg": "60e3",
	"./radio-perlis.jpg": "f627",
	"./radio-pulau-pinang.jpg": "4632",
	"./radio-red.jpg": "8f6b",
	"./radio-sabah-v.jpg": "3842",
	"./radio-sabah.jpg": "53b0",
	"./radio-sandakan.jpg": "76dd",
	"./radio-sarawak.jpg": "6bb3",
	"./radio-selangor.jpg": "8652",
	"./radio-sibu.jpg": "9beb",
	"./radio-sri-aman.jpg": "dda2",
	"./radio-tawau.jpg": "c516",
	"./radio-terengganu.jpg": "ddfc",
	"./radio-traxx.jpg": "f576",
	"./radio-wai-bidayuh.jpg": "9e87",
	"./radio-wai-iban.jpg": "7fff",
	"./radio-wai.jpg": "8efb",
	"./radioklasik.jpg": "01a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4aa0";